export const NOTE_STATUS = {
  NEW_APPOINTMENT: 0,
  CONTENT_PROCESSING: 1,
  CONTENT_UPLOADED: 2,
  NOTE_READY: 3,
  NOTE_UPLOADED_TO_MDS: 4,
  SIGNED: 5,
  EXPIRE_24: 6,
  EXPIRE_72: 7,
  NOTE_UPLOAD_FAILED: 8,
  NOTE_UPLOADED_TO_EHR: 9,
};
